export default {
    defaultPath: '/dashboard',
    
    layout: 'vertical', 
    preLayout: null, 
    collapseMenu: false, 
    layoutType: 'menu-light', 
    navIconColor: false,
    headerBackColor: 'header-default', 
    navBackColor: 'navbar-default', 
    navBrandColor: 'brand-default', 
    navBackImage: false, 
    rtlLayout: false, 
    navFixedLayout: true,
    headerFixedLayout: false, 
    boxLayout: false,
    navDropdownIcon: 'style1', 
    navListIcon: 'style1', 
    navActiveListColor: 'active-default', 
    navListTitleColor: 'title-default', // title-default, (title-blue, title-red, title-purple, title-lightblue, title-dark are not available in lite version)
    navListTitleHide: false, // not available in lite version
    configBlock: false, // not available in lite version
    layout6Background : 'linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)', // used only for pre-layout = layout-6
    layout6BackSize : '', // used only for pre-layout = layout-6
};
